import axios from "axios";
import ConstantList from "../appConfig";
// sản phẩm, sản phẩm đăng kí 
const API_PATH = ConstantList.API_EN_POINT + "/drug";
// lưu sp
export const saveDrug = (drug) => axios.post(API_PATH + "/save", drug);
// xem sp
export const getDrugById = (drugId) =>
  axios.get(API_PATH + "/getbyid/" + drugId);
// ds sản phẩm
export const pagingDrug = (searchObject) =>
  axios.post(API_PATH + "/search-by-page", searchObject);
// xóa
export const deleteDrug = (drugId) =>
  axios.delete(API_PATH + "/mark-delete/" + drugId);
// lấy tất cả
export const getAllDrug = () => axios.get(API_PATH + "/get-all-drug");
//
export const pagingDoseByDrugId = (searchObject) =>
  axios.post(API_PATH + "/search-dose-by-drug", searchObject);
//
export const getListDrugByStore = (searchObject) =>
  axios.post(API_PATH + "/get-list-drug-by-store", searchObject);
//
export const saveDrugSyncStore = (result) =>
  axios.post(API_PATH + "/sync-drug-from-store", result);
//Lấy tồn thuốc theo thầu
export const pageDrugInventory = (searchObject) =>
  axios.post(API_PATH + "/search-drug-inventory", searchObject);
//đồng bộ tồn thuốc
export const getDrugSyncInventory = (searchObject) =>
  axios.post(API_PATH + "/sync-drug-inventory", searchObject);
// ktra tuong tac thuoc
export const checkDrugInteractionsAlert = (searchObject) =>
  axios.post(API_PATH + "/check-drug-interaction", searchObject);
//Luu thuoc pha che
export const saveInfusionFormulaForDrug = (searchObject) =>
  axios.post(API_PATH + "/save-infusion-formula-drug-order", searchObject);
// kiểm tra dị ứng hoạt chất
export const checkAllergySpecialtyPharmacy = (obj) =>
  axios.post(API_PATH + "/check-allergy-specialty-pharmacy", obj);
// kiểm tra tồn
export const checkDrugInventory = (obj) =>
  axios.post(API_PATH + "/check-drug-inventory", obj);
// ds sản phẩm đăng kí
export const pagingDrugOrder = (searchObject) =>
  axios.post(API_PATH + "/search-by-page-drug-order", searchObject);
// bc sản phẩm đăng kí check quyen
export const searchDrugOrderReport = (searchObject) =>
  axios.post(API_PATH + "/search-drug-order-report", searchObject);
// cập nhật sp sử dụng
export const updateListDrugIsUsing = (obj) =>
  axios.post(API_PATH + "/update-is-using", obj);
// ds sản phẩm đăng kí đồng bộ
export const searchByPageDrugOrderSync = (searchObject) =>
  axios.post(API_PATH + "/search-by-page-drug-order-sync", searchObject);

